import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { LocationEntity } from './location.entity';
import { TripStopEntity } from './trip-stop.entity';

export type TripStopInspectionCondition = 'good' | 'fair' | 'poor';

/**
 * Per-stop *merchandiser* condition inspection. Driver inspects the
 * merchandiser at a stop and records its physical condition. Distinct from
 * `TripInspectionEntity` (which is pre/post-trip *vehicle* inspection).
 *
 * Photos for this inspection are linked via `TripStopPhotoEntity` rows
 * with `photoType='inspection'`.
 */
@Entity('trip_stop_inspection')
@Index('idx_trip_stop_inspection_stop', ['tripStopId'])
@Index('idx_trip_stop_inspection_location', ['locationId'])
export class TripStopInspectionEntity extends BaseEntity {
	@Column({ name: 'fk_trip_stop__id', type: 'int', unsigned: true })
	public tripStopId!: number;

	@Column({ name: 'fk_location__id', type: 'int', unsigned: true })
	public locationId!: number;

	@Column({ name: 'condition', type: 'varchar', length: 50, nullable: true })
	public condition?: TripStopInspectionCondition | null;

	@Column({ name: 'notes', type: 'text', nullable: true })
	public notes?: string | null;

	@Column({ name: 'inspectedAt', type: 'datetime' })
	public inspectedAt!: Date;

	@ManyToOne(() => TripStopEntity, (tripStop) => tripStop.inspections)
	@JoinColumn({ name: 'fk_trip_stop__id' })
	public fkTripStop?: TripStopEntity;

	@ManyToOne(() => LocationEntity)
	@JoinColumn({ name: 'fk_location__id' })
	public fkLocation?: LocationEntity;
}
